module.exports = __webpack_public_path__ + "resources/img/bg_cover_pricing_m_v2.75bbc1f13dc7177b0e7aa6f50662e6ef.png";